import React from "react";
import { Box, Flex } from "@chakra-ui/react";
import { useLandingTheme } from "../../LandingThemeContext";
import { QuestionCardMock } from "./QuestionCardMock";
import { FigureLabel, SECTION_GAP, ThemedBody, ThemedContainer, ThemedDisplayTitle } from "./ThemedLayout";

// A tinted full-bleed band — a change of density, not a second dark block. Multiple choice was the hero,
// so this shows only the two formats that differ.
export function ThemedQuestionTypes() {
  const theme = useLandingTheme();
  return (
    <Box as="section" mt={SECTION_GAP} bg={theme.isDark ? "transparent" : theme.color.surfaceAlt} borderTop={theme.isDark ? `1px solid ${theme.color.border}` : "none"} borderBottom={theme.isDark ? `1px solid ${theme.color.border}` : "none"} py={{ base: "64px", lg: "104px" }}>
      <ThemedContainer>
        <Flex direction={{ base: "column", lg: "row" }} gap={{ base: "40px", lg: "64px" }} align={{ base: "stretch", lg: "center" }}>
          <Box flex="4" minW={0}>
            <FigureLabel figureNumber={4} label="Question formats" />
            <ThemedDisplayTitle>The format that works for you.</ThemedDisplayTitle>
            <ThemedBody mt="16px" maxW="400px">
              Multiple choice for speed. Free response when you need to explain it. Case scenarios when the exam will. Switch any time.
            </ThemedBody>
          </Box>
          <Flex flex="8" minW={0} direction={{ base: "column", md: "row" }} gap="24px" align="flex-start">
            <QuestionCardMock format="freeResponse" flex="1" />
            <QuestionCardMock format="caseScenario" flex="1" />
          </Flex>
        </Flex>
      </ThemedContainer>
    </Box>
  );
}
